(() => {
  const STORAGE_KEY = 'zs-collection-columns-v2';
  const mobileMedia = window.matchMedia('(max-width: 989px)');

  const getSavedView = (component) => {
    const mobile = mobileMedia.matches;
    const fallback = mobile ? component.dataset.zsMobileColumns : component.dataset.zsGridColumns;

    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return String(saved[mobile ? 'mobile' : 'desktop'] || fallback);
    } catch (_error) {
      return String(fallback);
    }
  };

  const setPressedState = (component, view) => {
    component.querySelectorAll('[data-zs-grid-view]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.zsGridView === view));
    });
  };

  const applyView = (component, view, persist = false) => {
    const mobile = mobileMedia.matches;
    const allowed = mobile ? ['1', '2'] : ['3', '4', '5'];
    const safeView = allowed.includes(String(view)) ? String(view) : mobile ? '2' : '4';

    component.dataset.zsActiveColumns = safeView;
    setPressedState(component, safeView);

    if (!persist) return;
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      saved[mobile ? 'mobile' : 'desktop'] = safeView;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    } catch (_error) {
      // The selector remains functional when storage is unavailable.
    }
  };

  const init = (component) => {
    if (component.dataset.zsCollectionReady === 'true') return;
    component.dataset.zsCollectionReady = 'true';
    applyView(component, getSavedView(component));

    component.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zs-grid-view]');
      if (!button) return;
      applyView(component, button.dataset.zsGridView, true);
    });
  };

  const initAll = () => document.querySelectorAll('collection-component.zs-collection').forEach(init);
  const onResize = () => document.querySelectorAll('collection-component.zs-collection').forEach((component) => {
    applyView(component, getSavedView(component));
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(onResize, 120);
  });
  mobileMedia.addEventListener('change', onResize);
})();
